// import axios from 'axios';
// import { setupCache } from 'axios-cache-adapter'
import { setup } from 'axios-cache-adapter';
import { API_URL } from '@/constants/consts';

export const API = setup({
  baseURL: `${API_URL}/`,
  cache: {
    maxAge: 15 * 60 * 1000
  }
})



// WEBPACK FOOTER //
// ./src/plugins/Api.js